import template from './cpwd.html';
import controller from './cpwd.controller';
import './cpwd.scss';

let cpwdComponent = {
  bindings: {},
  template,
  controller
};

export default cpwdComponent;



// WEBPACK FOOTER //
// ./client/app/common/cpwd/cpwd.component.js